// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner_container {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    gap: 16px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.partner_main_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.partner_section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    background-color: var(--bg);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.partner_section_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.partner_section_title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.partner_timeframe_select {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: var(--text-secondary);
}

.partner_stats_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.partner_stat_item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 10px 12px;
    background-color: var(--bg-card);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.partner_stat_label {
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 500;
}

.partner_stat_value {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.partner_update_row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
}

.partner_input_group {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.partner_input_label {
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 500;
}

.partner_input {
    width: 100px;
    padding: 6px 10px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    font-size: 13px;
    background-color: var(--bg-card);
    color: var(--text-primary);
}

.partner_update_button {
    background-color: var(--primary);
    padding: 7px 16px;
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
}

.partner_update_button:hover {
    background-color: var(--primary-hover);
}

.partner_commission_total {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background-color: var(--bg-card);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.partner_commission_total_value {
    font-size: 16px;
    font-weight: 700;
    color: var(--primary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserPartner/userPartner.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB","sourcesContent":[".partner_container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    gap: 16px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.partner_main_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.partner_section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n    background-color: var(--bg);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.partner_section_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.partner_section_title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.partner_timeframe_select {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.partner_stats_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n}\n\n.partner_stat_item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 10px 12px;\n    background-color: var(--bg-card);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.partner_stat_label {\n    font-size: 12px;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.partner_stat_value {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.partner_update_row {\n    display: flex;\n    align-items: flex-end;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.partner_input_group {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.partner_input_label {\n    font-size: 12px;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.partner_input {\n    width: 100px;\n    padding: 6px 10px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    font-size: 13px;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n}\n\n.partner_update_button {\n    background-color: var(--primary);\n    padding: 7px 16px;\n    border-radius: var(--radius-sm);\n    border: none;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n}\n\n.partner_update_button:hover {\n    background-color: var(--primary-hover);\n}\n\n.partner_commission_total {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    background-color: var(--bg-card);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.partner_commission_total_value {\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
